import COUNTRIES from "./constants/countries";


const {
    PUBLIC_URL,
    NODE_ENV,
    REACT_APP_BUILDTIME,
    TBX_CLIENT_CO,
    TBX_CLIENT_KEY,
    TBX_CLIENT_LANG,
    TBX_CLIENTS_LIST,
    TBX_CLOUDPASS_API,
    TBX_EXPERIENCE_CDN_URL,
    TBX_EXP_AUTH_USER,
    TBX_EXP_AUTH_PASS,
    TBX_EXP_DISABLE_AUTH,
    TBX_PLAYER_VERSION,
    TBX_PLAYER_UNITY_MODULE_VERSION,
    TBX_UNITY_IMAGES_API,
    TBX_UNITY_API,
    DEBUG,
} = window.__TBX_ENV__  || {};
let tbxClientsJSON = null;
let tbxClientKey = TBX_CLIENT_KEY;

if (typeof (TBX_CLIENTS_LIST) === 'string') {
    try {
        tbxClientsJSON = JSON.parse(TBX_CLIENTS_LIST);
        const { pathname } = window.location
        const pathUrl = pathname.slice(1,pathname.length).split('/')[0]?.toUpperCase();
        const pathCountry = COUNTRIES.find(({ code }) => code === pathUrl)?.code;
        const pathClientDefault = tbxClientsJSON.find((client)=>client?.default)
        const pathClient = tbxClientsJSON.find((client)=>{
          return !!pathUrl && client?.country === pathUrl
        })

        if (pathClient || pathCountry) tbxClientsJSON = [(pathClient || {...pathClientDefault, country: pathCountry})];

    } catch (e) {
        console.error('[ENV Config] >>> Invalid TBX_CLIENTS_LIST value: ', e);
    }
}

export function getDeviceTBXUserAgent(config = {}) {
    //INFO: Hack para web (que los browsers no permiten sobreescritura de user-agent)
    // pero la función debe existir para el ConfiguratorManager.
    return;
}

export const IS_DEBUG = DEBUG ? true : false
export const TBX_ENVS = {
    PUBLIC_URL,
    NODE_ENV,
    REACT_APP_BUILDTIME,
    TBX_CLIENT_CO,
    TBX_CLIENT_KEY: tbxClientKey,
    TBX_CLIENT_LANG,
    TBX_CLIENTS_LIST: tbxClientsJSON,
    TBX_CLOUDPASS_API,
    TBX_EXPERIENCE_CDN_URL,
    TBX_EXP_AUTH_USER,
    TBX_EXP_AUTH_PASS,
    TBX_EXP_DISABLE_AUTH,
    TBX_PLAYER_VERSION,
    TBX_PLAYER_UNITY_MODULE_VERSION,
    TBX_UNITY_IMAGES_API,
    TBX_UNITY_API,
}